import React, { createContext, useContext, useState, useEffect } from 'react';
import { STORAGE_KEYS } from '../config/constants';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    // Check if user is stored in localStorage
    const storedUser = localStorage.getItem(STORAGE_KEYS.USER);
    const storedUserId = localStorage.getItem('user_id');
    const storedAppSpecificId = localStorage.getItem('app_specific_id');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      // 确保user对象包含user_id和app_specific_id
      if (storedUserId) {
        parsedUser.user_id = storedUserId;
      }
      if (storedAppSpecificId) {
        parsedUser.app_specific_id = storedAppSpecificId;
      }
      setUser(parsedUser);
    }
    setLoading(false);
  }, []);

  const login = (userData, loginResponse = null) => {
    // 从登录响应中提取user_id和app_specific_id
    let enhancedUserData = { ...userData };

    if (loginResponse) {
      enhancedUserData.user_id = loginResponse.user_id;
      enhancedUserData.app_specific_id = loginResponse.app_specific_id;
      enhancedUserData.platform_type = loginResponse.platform_type;
    }

    setUser(enhancedUserData);
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(enhancedUserData));

    // 单独存储user_id和app_specific_id以便快速访问
    if (enhancedUserData.user_id) {
      localStorage.setItem('user_id', enhancedUserData.user_id);
    }
    if (enhancedUserData.app_specific_id) {
      localStorage.setItem('app_specific_id', enhancedUserData.app_specific_id);
    }

    setShowLogin(false);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem(STORAGE_KEYS.USER);
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem('user_id');
    localStorage.removeItem('app_specific_id');
  };

  const value = {
    user,
    loading,
    showLogin,
    setShowLogin,
    login,
    logout,
    isAuthenticated: !!user,
    // 新增：方便访问user_id和app_specific_id
    userId: user?.user_id,
    appSpecificId: user?.app_specific_id
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext };

